import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_BASE_URL as BASE_URL } from '@/environments/environment';

export interface CustomerNotificationItemDto {
  id: string;
  type?: string | null;
  metadata?: unknown;
  notificationKey: string;
  languageCode: string;
  title: string;
  body: string;
  sourceReferenceType: string | null;
  sourceReferenceId: string | null;
  actionType: string | null;
  actionReferenceType: string | null;
  actionReferenceId: string | null;
  isRead: boolean;
  readAtUtc: string | null;
  archivedAtUtc: string | null;
  createdAtUtc: string;
}

export interface CustomerNotificationsResponse {
  items: CustomerNotificationItemDto[];
  page: number;
  pageSize: number;
  totalCount: number;
}

export interface CustomerUnreadNotificationsCountResponse {
  count: number;
}

@Injectable({ providedIn: 'root' })
export class CustomerNotificationsApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${BASE_URL}/api/v1/customer/notifications`;

  list(page = 1, pageSize = 32, archived = false) {
    return this.http.get<CustomerNotificationsResponse>(this.base, {
      params: {
        page,
        pageSize,
        archived,
      },
    });
  }

  getUnreadCount() {
    return this.http.get<CustomerUnreadNotificationsCountResponse>(
      `${this.base}/unread-count`,
    );
  }

  markRead(notificationId: string) {
    return this.http.put<void>(`${this.base}/${notificationId}/read`, {});
  }

  markUnread(notificationId: string) {
    return this.http.delete<void>(`${this.base}/${notificationId}/read`);
  }

  archive(notificationId: string) {
    return this.http.put<void>(`${this.base}/${notificationId}/archive`, {});
  }

  unarchive(notificationId: string) {
    return this.http.delete<void>(`${this.base}/${notificationId}/archive`);
  }

  delete(notificationId: string) {
    return this.http.delete<void>(`${this.base}/${notificationId}`);
  }
}
